module.exports = __webpack_public_path__ + "solution-build/img/solutionItem3@2.7a5e25fd.jpg";